import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/shared/services';
import { EventsModel } from '@app/events/events-form/events.model'
import { EventsFormComponent } from './events-form/events-form.component';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { DataArrayService } from './events.service';
import { EventsEditFormComponent } from './events-edit-form/events-edit-form.component';
import { DataStorageService } from '@app/shared/services/data-storage.service';
import esJson from '../../assets/i18n/es.json';
import enJson from '../../assets/i18n/en.json';
import { DashboardService } from '@app/dashboard/dashboard.service';
import { DialogComponent } from '@app/workers/dialog/dialog.component';
import { BankTransfersDialogComponent } from './bank-transfers-dialog/bank-transfers-dialog.component';
import saveAs from 'file-saver';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss'],
  standalone: false
})

export class EventsComponent implements OnInit {
  langJson = (localStorage.getItem('lang') === 'es') ? esJson : enJson;
  buttons_filter = [{ id: 'boton_asc_name', contenido: this.langJson.events.ascFilter }, { id: 'boton_desc_name', contenido: this.langJson.events.ascFilter }];
  abrirFormulario = false;
  dataArray: string[];
  data = [];
  eventId: string = JSON.parse(localStorage.getItem('eventId'));
  showAlert = false;
  alertMessage = '';
  alertType: 'success' | 'error' | 'info' | 'warn' = 'info';

  constructor(
    public authService: AuthenticationService,
    public dialog: MatDialog,
    private dataArrayService: DataArrayService,
    public dataStorageService: DataStorageService,
    public dashboardService: DashboardService
  ) { }

  ngOnInit(): void {
    this.authService.setLoader(true);
    this.dataStorageService.fetchTicketTypes().subscribe(response => {
      this.data = response;
      this.data = this.data.sort((a, b) => {
        return (a.name.toLowerCase()).localeCompare((b.name.toLowerCase()), undefined, { numeric: true, sensitivity: 'base' });
      });
      this.filteredData = this.data.slice();
      this.dataArrayService.setData(this.data);
      this.authService.setLoader(false);
    });
    
  }

  flag: boolean = false;
  botonActivo: any;
  orden_ascendente = true;

  activarBoton(button: any) {
    if (!this.flag) {
      this.botonActivo = document.getElementById('boton_asc_name');
    }

    if (this.botonActivo) {
      this.botonActivo.classList.remove("clicked");
    }

    this.botonActivo = button;
    button.classList.add("clicked");
    this.flag = true;

    if (button.id === this.buttons_filter[1].id) {
      this.orden_ascendente = false;
      this.data = this.data.sort((a, b) => {
        return (b.name.toLowerCase()).localeCompare((a.name.toLowerCase()), undefined, { numeric: true, sensitivity: 'base' });
      });
      this.filteredData = this.filteredData.sort((a, b) => {
        return (b.name.toLowerCase()).localeCompare((a.name.toLowerCase()), undefined, { numeric: true, sensitivity: 'base' });
      });
    } else if (button.id === this.buttons_filter[0].id) {
      this.orden_ascendente = true; //!!!!!!
      this.data = this.data.sort((a, b) => {
        return (a.name.toLowerCase()).localeCompare((b.name.toLowerCase()), undefined, { numeric: true, sensitivity: 'base' });
      });
      this.filteredData = this.filteredData.sort((a, b) => {
        return (a.name.toLowerCase()).localeCompare((b.name.toLowerCase()), undefined, { numeric: true, sensitivity: 'base' });
      });
    }
  }

  hidden = false;

  buscador() {
    this.hidden = !this.hidden;
  }

  filteredData = [];
  searchValue = '';

  filtro_buscador() {
    if (this.searchValue === '') {
      this.filteredData = this.data.slice();
    } else {
      this.filteredData = this.data.filter(data_filtrado => data_filtrado.name.toLowerCase().includes(this.searchValue.toLowerCase()));
    }
  }

  abrirFormularioPopup() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxWidth = '95vw';
    dialogConfig.width = '95vw';
    dialogConfig.maxHeight = '95vh';
    dialogConfig.height = '95vh';
    dialogConfig.autoFocus = false

    const dialog_evento = this.dialog.open(EventsFormComponent, dialogConfig);
    dialog_evento.afterClosed().subscribe(data_local => {
      if (data_local != undefined) {
        this.actualizar_lista(data_local);
        this.alertMessage = this.langJson.events.createSuccess;
        this.alertType = 'success';
        this.showAlert = true;
      }
      this.authService.setLoader(false);
    });
  }

  actualizar_lista(value: any) {
    this.data.push(value);
    this.filteredData.push(value);

    if (!this.orden_ascendente) {
      this.data = this.data.sort((a, b) => {
        return (b.name.toLowerCase()).localeCompare((a.name.toLowerCase()), undefined, { numeric: true, sensitivity: 'base' });
      });
      this.filteredData = this.filteredData.sort((a, b) => {
        return (b.name.toLowerCase()).localeCompare((a.name.toLowerCase()), undefined, { numeric: true, sensitivity: 'base' });
      });
    } else if (this.orden_ascendente) {
      this.data = this.data.sort((a, b) => {
        return (a.name.toLowerCase()).localeCompare((b.name.toLowerCase()), undefined, { numeric: true, sensitivity: 'base' });
      });
      this.filteredData = this.filteredData.sort((a, b) => {
        return (a.name.toLowerCase()).localeCompare((b.name.toLowerCase()), undefined, { numeric: true, sensitivity: 'base' });
      });
    }
  }

  public posicion = 0;
  valor_nombre_pred = "";
  valor_attendees_pred = "";
  valor_fecha_inicio_pred: any;
  valor_fecha_fin_pred: any;
  valor_has_vouchers_pred: any;
  valor_control_accesos_pred: any;
  data_form: any;

  abrirFormularioEditPopup(evento: any) {
    this.posicion = this.data.indexOf(evento);
    this.valor_nombre_pred = evento.name;
    this.valor_attendees_pred = evento.attendees;
    this.valor_fecha_inicio_pred = evento.startingDate;
    this.valor_fecha_fin_pred = evento.endingDate;
    this.valor_has_vouchers_pred = evento.hasVouchers;
    this.valor_control_accesos_pred = evento.hasAccessControl;
    this.dataArrayService.setEventClicked(evento);
    this.data_form = evento;

    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxWidth = '95vw';
    dialogConfig.width = '95vw';
    dialogConfig.maxHeight = '95vh';
    dialogConfig.height = '95vh';
    dialogConfig.data = this.data_form;
    dialogConfig.autoFocus = false

    const dialog_evento = this.dialog.open(EventsEditFormComponent, dialogConfig);
    dialog_evento.afterClosed().subscribe(data_local => {
      if (data_local != undefined) {
        if (data_local.deleted) {
          this.alertMessage = this.langJson.events.deleteSuccess;
          this.alertType = 'success';
          this.showAlert = true;
        }
        if (data_local.edited) {
          this.alertMessage = this.langJson.events.editSuccess;
          this.alertType = 'success';
          this.showAlert = true;
        }
        this.actualizar_evento_lista(data_local.data, this.posicion);
        this.authService.setLoader(false);
      }
    });
  }

  actualizar_evento_lista(value: any, posicion: number) {
    if (this.dataArrayService.delete_event_state === "actualizar_evento") {
      this.data[posicion] = value;
      this.filteredData[posicion] = value;
    } else {
      this.data.splice(posicion, 1);
      this.filteredData.splice(posicion, 1);
    }

    if (!this.orden_ascendente) {
      this.data = this.data.sort((a, b) => {
        return (b.name.toLowerCase()).localeCompare((a.name.toLowerCase()), undefined, { numeric: true, sensitivity: 'base' });
      });
      this.filteredData = this.filteredData.sort((a, b) => {
        return (b.name.toLowerCase()).localeCompare((a.name.toLowerCase()), undefined, { numeric: true, sensitivity: 'base' });
      });
    } else if (this.orden_ascendente) {
      this.data = this.data.sort((a, b) => {
        return (a.name.toLowerCase()).localeCompare((b.name.toLowerCase()), undefined, { numeric: true, sensitivity: 'base' });
      });
      this.filteredData = this.filteredData.sort((a, b) => {
        return (a.name.toLowerCase()).localeCompare((b.name.toLowerCase()), undefined, { numeric: true, sensitivity: 'base' });
      });
    }
  }

  downloadAttendees(evento: any) {
    if (!evento || !evento.id) {
      this.alertMessage = 'No se puede descargar el listado de asistentes.';
      this.alertType = 'error';
      this.showAlert = true;
      return;
    }

    this.authService.setLoader(true);
    this.dataStorageService.downloadAttendeesList(evento.id).subscribe(
      response => {
        const filename = 'Asistentes_' + evento.name.replace(/[^a-z0-9]/gi, '_') + '.xlsx';
        const blob: any = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8; charset=utf-8' });
        saveAs(blob, filename);
        this.authService.setLoader(false);
        this.alertMessage = this.langJson.events.downloadAttendeesSuccess;
        this.alertType = 'success';
        this.showAlert = true;
      },
      err => {
        console.error(err);
        this.authService.setLoader(false);
        this.alertMessage = 'Error al descargar el listado de asistentes: ' + (err.error || 'Error desconocido');
        this.alertType = 'error';
        this.showAlert = true;
      }
    );
  }
  
  // CHAPUZA COCHES ELEGANTES
  getBankTransfers() {
    this.authService.setLoader(true);
    this.dataStorageService.getBankTransfersReport(this.eventId).subscribe(
      response => {
        this.authService.setLoader(false);
        const dialogConfig = new MatDialogConfig();
        dialogConfig.width = '90vw';
        dialogConfig.maxWidth = '900px';
        dialogConfig.maxHeight = '90vh';
        dialogConfig.autoFocus = false;
        dialogConfig.data = {
          transfers: response?.data || [],
          eventId: this.eventId
        };
        this.dialog.open(BankTransfersDialogComponent, dialogConfig);
      },
      err => {
        console.error(err);
        this.authService.setLoader(false);
        this.alertMessage = this.langJson.events.bankTransfersLoadError +
          (err?.error ? ': ' + (typeof err.error === 'string' ? err.error : '') : '');
        this.alertType = 'error';
        this.showAlert = true;
      }
    );
  }

  reserveTickets(evento: any) {
    if (!evento || !evento.id) {
      this.alertMessage = 'No se pueden reservar entradas para este evento.';
      this.alertType = 'error';
      this.showAlert = true;
      return;
    }

    const dialogRef2 = this.dialog.open(DialogComponent, {
      width: '350px',
      data: {
        message: this.langJson.events.reserveTicketsMessage,
        upload: false,
        type: 'booking'
      }
    });

    dialogRef2.afterClosed().subscribe(result => {
      if (result && result.numEntradas) {
        const numTickets = parseInt(result.numEntradas, 10);

        if (numTickets > 0) {
          this.authService.setLoader(true);
          const filename = 'ENTRADAS_' + evento.name.replace(/[^a-z0-9]/gi, '_') + '.pdf';

          const purchaseData: any = {
            ticketTypes: [{
              ticketTypeId: evento.id,
              quantity: numTickets
            }],
            import: 0,
            paymentMethod: 'free'
          };

          this.dataStorageService.reserveEventTickets(purchaseData).subscribe(
            response => {
              // El PDF viene en base64, necesitamos convertirlo a Blob
              const base64Data = response.data.pdf;
              const byteCharacters = atob(base64Data);
              const byteNumbers = new Array(byteCharacters.length);
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              const byteArray = new Uint8Array(byteNumbers);
              const blob = new Blob([byteArray], { type: 'application/pdf' });
              saveAs(blob, filename);

              this.authService.setLoader(false);

              this.alertMessage = this.langJson.events.reserveTicketsSuccess;
              this.alertType = 'success';
              this.showAlert = true;
            },
            err => {
              console.error(err);
              this.authService.setLoader(false);

              this.alertMessage = 'Error al reservar las entradas: ' + (err.error || 'Error desconocido');
              this.alertType = 'error';
              this.showAlert = true;
            }
          );
        } else {
          this.alertMessage = 'El número de entradas debe ser mayor que 0.';
          this.alertType = 'warn';
          this.showAlert = true;
        }
      }
    });
  }
}

